import _Promise from 'babel-runtime/core-js/promise';
import { withServiceImplementation } from '@myaccount/utils';
import IMyAccountContainer from './MyAccountContainerInterface';

export default withServiceImplementation(IMyAccountContainer, {
  goBack: function goBack(props) {
    return function () {
      props.goBack();
      return _Promise.resolve('[myAccountContainer] goBack success');
    };
  },
  goTo: function goTo(props) {
    return function (eventData) {
      props.goTo(eventData);
      return _Promise.resolve('[myAccountContainer] goTo success');
    };
  },

  replaceTo: function replaceTo(_ref) {
    var dispatchReplace = _ref.dispatchReplace;
    return function (eventData) {
      dispatchReplace(eventData);
      return _Promise.resolve('[myAccountContainer] replaceTo success');
    };
  },

  getCurrentLocation: function getCurrentLocation(_ref2) {
    var location = _ref2.location;
    return function () {
      return _Promise.resolve({ location: location });
    };
  },

  getCanGoBack: function getCanGoBack(props) {
    return function () {
      return _Promise.resolve(props.canGoBack);
    };
  }
});